'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ResponsiveImageFACC = require('./ResponsiveImageFACC');

var _ResponsiveImageFACC2 = _interopRequireDefault(_ResponsiveImageFACC);

var _ProgressiveBackgroundImage = require('./progressiveImages/ProgressiveBackgroundImage');

var _ProgressiveBackgroundImage2 = _interopRequireDefault(_ProgressiveBackgroundImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Lib
var ResponsiveProgressiveBackgroundImage = function ResponsiveProgressiveBackgroundImage(_ref) {
    var imageType = _ref.imageType,
        imageDetails = _ref.imageDetails,
        size = _ref.size;

    var aspectRatio = imageDetails.get('height') / imageDetails.get('width');
    var thumbnail = imageDetails.get('thumb');

    return _react2.default.createElement(
        _ResponsiveImageFACC2.default,
        { imageType: imageType, imageDetails: imageDetails, size: size },
        function (imageSource) {
            return _react2.default.createElement(_ProgressiveBackgroundImage2.default, { source: imageSource, aspectRatio: aspectRatio, thumbnail: thumbnail });
        }
    );
};

ResponsiveProgressiveBackgroundImage.propTypes = {
    imageType: _propTypes2.default.string.isRequired,
    imageDetails: _propTypes2.default.object.isRequired,
    size: _propTypes2.default.number.isRequired
};

exports.default = ResponsiveProgressiveBackgroundImage;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/images/ResponsiveProgressiveBackgroundImage.js
// module id = 1900
// module chunks = 0